import { IconPropsBase } from './IconPropsBase';

export default function FilterListIcon({ size = 20, color = 'currentColor' }: IconPropsBase) {
  if (size > 20) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
        <path fill={color} d="M10.25 17.75v-1.5h3.5v1.5Zm-4-5.2v-1.5h11.5v1.5Zm-3-5.175v-1.5h17.5v1.5Z" />
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
        <path fill={color} d="M8.208 14.292v-1.084h3.584v1.084Zm-3-3.917V9.292h9.584v1.083Zm-2-3.896V5.396h13.584v1.083Z" />
      </svg>
    );
  }
}
